<template>
    <div class="tab__nav-container">
        <nav class="tab__nav">
            <button 
                v-for="(title, id) in tabs"
            
                class="tab--link alt" 
                :class="{active: accordion.isActive(id)}"
                
                role="tab"
                data-tab

                @click="toggleItem(id)"
            >
                {{ title }}
            </button>
        </nav>
    </div>
</template>

<script setup>
    import { inject } from 'vue';

    const { tabs, accordion } = inject('tabs')

    const toggleItem = (id) => {
        if(accordion.value.toggleItem){
            accordion.value.toggleItem(id)
        }
    }
</script>